import type { TAppConfig } from "~ui/@application/configs/config-schema.ts";

import { createPinia } from "pinia";

export function createPiniaInstance(config: TAppConfig) {
  void config;

  return createPinia();
}
